import { Link, useLocation } from "react-router-dom";

export function Header() {
	const location = useLocation();
	const isTaskList = location.pathname === "/tasks";

	return (
		<header className="bg-white border-b border-gray-200 sticky top-0 z-50">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="flex items-center justify-between h-16">
					<Link
						to="/tasks"
						className="flex items-center gap-2 text-xl font-bold text-primary-600 hover:text-primary-700 transition-colors"
					>
						<svg
							className="w-8 h-8"
							fill="none"
							stroke="currentColor"
							viewBox="0 0 24 24"
							aria-hidden="true"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth={2}
								d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
							/>
						</svg>
						<span className="hidden sm:inline">タスク管理</span>
					</Link>

					<nav className="flex items-center gap-4">
						{!isTaskList && (
							<Link to="/tasks" className="text-gray-600 hover:text-gray-900 transition-colors">
								タスク一覧に戻る
							</Link>
						)}
					</nav>
				</div>
			</div>
		</header>
	);
}
